import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.user');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'wiz-component-nav-user',
template: templateSource || '',
    styles: [``],
})
export class ComponentNavUserComponent implements OnInit, OnDestroy {

    private routerSub: Subscription;

    public toggleMenu = false;
    public userinfo: any = null;
    public session: any = null;

    public menus = [
        { title: '대시보드', icon: 'fas fa-home', url: '/home' },
        {
            title: '농장관리',
            icon: 'fas fa-tractor',
            baseUrl: '/user/farm',
            url: '/user/farm/dashboard/0'
        },
        {
            title: '선별기 A/S',
            icon: 'fas fa-wrench',
            show: false,
            child: [
                { title: 'A/S 접수목록', url: '/user/as/list' },
                { title: 'A/S 신청하기', url: '/user/as/apply' }
            ]
        },
        {
            title: '데이터통계',
            icon: 'fas fa-chart-column',
            show: false,
            child: [
                { title: '날짜별선별통계', url: '/user/monitoring/statistic' },
                { title: '계란시세정보', url: '/user/monitoring/eggprice' }
            ]
        },
        {
            title: '고객센터',
            icon: 'fas fa-user-cog',
            show: false,
            child: [
                { title: '공지사항', url: '/community/notice/list' },
                { title: '문의사항', url: '/community/faq/list' }
            ]
        },
    ];

    constructor(@Inject( Service)         public service: Service,@Inject( Router    )         private router: Router    ) { }

    async ngOnInit() {
        await this.service.init();

        const { code, data } = await wiz.call('load');
        if (code === 200) {
            this.userinfo = data;
        } else {
            this.userinfo = null;
        }
        this.openMenuByUrl(this.router.url);

        this.routerSub = this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(async () => {
                this.openMenuByUrl(this.router.url);
                await this.service.render();
            });

        await this.service.auth.allow();
        this.session = this.service.auth.session;
        await this.service.render();
    }

    ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    async toggle() {
        this.toggleMenu = !this.toggleMenu;
        await this.service.render();
    }

    async openMenuAndMove(menu) {

        if (!menu.child || menu.child.length === 0) return;

        const first = menu.child[0];
        this.router.navigateByUrl(first.move || first.url);

        this.closeNavOnMobile();
        await this.service.render();
    }

    isSubmenuActive(menu) {
        return !!menu.show || this.isParentActive(menu);
    }

    isMenuActive(menu) {
        const current = this.router.url.split('?')[0];

        if (menu.baseUrl) {
            return current === menu.baseUrl || current.startsWith(menu.baseUrl + '/');
        }

        if (menu.url) {
            return current === menu.url || current.startsWith(menu.url + '/');
        }

        return false;
    }

    isParentActive(menu) {
        if (!menu.child) return false;

        const currentUrl = this.router.url;
        return menu.child.some((child: any) =>
            currentUrl.startsWith(child.url)
        );
    }

    isMobile(): boolean {
        return window.innerWidth < 1024;
    }

    closeNavOnMobile() {
        if (this.isMobile()) {
            this.toggleMenu = false;
        }
    }

    async closeAllMenus() {
        this.menus.forEach(menu => {
            if (menu.child) {
                menu.show = false;
            }
        });

        this.closeNavOnMobile();
        await this.service.render();
    }

    openMenuByUrl(url) {
        this.menus.forEach(menu => {
            if (menu.child) {
                menu.show = menu.child.some(child =>
                    url.startsWith(child.url)
                );
            }
        });
    }
}

export default ComponentNavUserComponent;